// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .schedTable {
  flex: 3 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: #f6f3f3;
  color: #000;
  padding: 20px;
}
.theme-light .schedTable table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 20px 0px;
}
.theme-light .schedTable table th {
  background-color: white;
  color: #000;
  font-weight: 400;
  padding: 10px 20px;
  text-align: left;
  border-bottom: 1px solid;
}
.theme-light .schedTable table td {
  padding: 10px 20px;
  border-bottom: 1px solid;
}
.theme-light .schedTable table tr {
  transition: background-color 0.3s;
  cursor: pointer;
}
.theme-light .schedTable table tr:hover {
  background-color: white;
}
.theme-dark .schedTable {
  flex: 3 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: #333;
  color: #fffef9;
  padding: 20px;
}
.theme-dark .schedTable table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 20px 0px;
}
.theme-dark .schedTable table th {
  background-color: #222;
  color: #fffef9;
  font-weight: 400;
  padding: 10px 20px;
  text-align: left;
  border-bottom: 1px solid;
}
.theme-dark .schedTable table td {
  padding: 10px 20px;
  border-bottom: 1px solid;
}
.theme-dark .schedTable table tr {
  transition: background-color 0.3s;
  cursor: pointer;
}
.theme-dark .schedTable table tr:hover {
  background-color: #222;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/schedules/schedTable.scss"],"names":[],"mappings":"AAqBI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AAFJ;AAII;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAGQ;EACI,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,wBAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,eAAA;AAHZ;AAKY;EACA,uBAAA;AAHZ;ADbI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;AAiCJ;AA/BI;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAiCR;AAhCQ;EACI,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AAkCZ;AA/BQ;EACI,kBAAA;EACA,wBAAA;AAiCZ;AA9BQ;EACI,iCAAA;EACA,eAAA;AAgCZ;AA9BY;EACA,sBAAA;AAgCZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.schedTable {\n  @include themify($themes) {\n    flex: 3;\n    position: sticky;\n    top: 70px;\n    height: calc(100vh - 70px);\n    overflow: scroll;\n    background-color: themed(\"bgSoft\");\n    color: themed(\"textColor\");\n    padding: 20px;\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        border-spacing: 0;\n        margin: 20px 0px;\n        th {\n            background-color: themed(\"bg\");\n            color: themed(\"textColor\");\n            font-weight: 400;\n            padding: 10px 20px;\n            text-align: left;\n            border-bottom: 1px solid themed(\"borderColor\");\n        }\n    \n        td {\n            padding: 10px 20px;\n            border-bottom: 1px solid themed(\"borderColor\");\n        }\n    \n        tr {\n            transition: background-color 0.3s;\n            cursor: pointer;\n    \n            &:hover {\n            background-color: themed(\"bg\");\n            }\n\n        }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
